import React from "react";

const Dots = () => {

}

export default Dots;